import { FC, useContext } from 'react'
import { ApiChatPreviewTotalInfo } from '../../../api/chats/types/ApiChatPreview'
import { useTranslation } from 'react-i18next'
import { MoneyView } from '../../../common/components/MoneyView'
import { ChatDesktopPreviewTable } from './ChatDesktopPreviewTable'
import { PreviewEditsContext } from '../../../features/preview-edits/model/PreviewEditsContext'
import { PreviewSkeleton } from '../../../features/preview-edits/ui/PreviewSkeleton'

export const ChatDesktopPreviewTotal: FC<{ totalInfo: ApiChatPreviewTotalInfo | null }> = ({ totalInfo }) => {
  const { t } = useTranslation()
  const { dirty } = useContext(PreviewEditsContext)

  return (
    <ChatDesktopPreviewTable>
      <thead>
        <tr>
          <th>{t('Gross')}</th>
          <th>{t('Base')}</th>
          <th>{t('VAT')}</th>
          <th>{t('Taxes')}</th>
          <th>{t('Total')}</th>
        </tr>
      </thead>

      {totalInfo && (
        <tbody>
          <tr>
            {dirty ? (
              <>
                <td>
                  <PreviewSkeleton />
                </td>
                <td>
                  <PreviewSkeleton />
                </td>
                <td>
                  <PreviewSkeleton />
                </td>
                <td>
                  <PreviewSkeleton />
                </td>
                <td>
                  <PreviewSkeleton />
                </td>
              </>
            ) : (
              <>
                <td>
                  <MoneyView value={totalInfo.grossAmount} />
                </td>

                <td>
                  <MoneyView value={totalInfo.base} />
                </td>

                <td>{totalInfo.vat}</td>

                <td>
                  <MoneyView value={totalInfo.taxes} />
                </td>

                <td>
                  <strong>
                    <MoneyView value={totalInfo.totalAmount} />
                  </strong>
                </td>
              </>
            )}
          </tr>
        </tbody>
      )}
    </ChatDesktopPreviewTable>
  )
}
